module.exports = __webpack_public_path__ + "img/CAVIN_Logo_white.2566a80d.png";